import React, { Component, PropTypes } from 'react';

export default class Disclaimer extends Component {
  constructor(props) {
    super(props);
  }


  render() {

    let hasAsterisk = this.props.hasAsterisk;

    let disclaimer = '';

    if (hasAsterisk == 'true') {
      disclaimer = <div className="festivalDisclaimer-wrapper">
        *Thanks to Santa Clara University for allowing us to host the event on their beautiful campus. Please note that this event is not a function of the university.
      </div>;
    } else if (hasAsterisk == 'false') {
      disclaimer = <div className="festivalDisclaimer-wrapper">
        Thanks to Santa Clara University for allowing us to host the event on their beautiful campus. Please note that this event is not a function of the university.
      </div>;
    }



    return(
      <div>
        {disclaimer}
      </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/components/festival/Disclaimer.jsx